<div class="container">
    <mat-card class="mat-elevation-z0">
        <div>
            <cl-rptmng-desk [Id]="rptmngId" [AppKey]="appKey">
            </cl-rptmng-desk>
        </div>
    </mat-card>
</div>